module.exports = __webpack_public_path__ + "static/media/Twitter.f03e98ad.svg";